/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/8/13
 * Time: 1:19 PM
 * To change this template use File | Settings | File Templates.
 *
 * the model for the Single Select component
 */
define(function (require) {
    "use strict";

    var Backbone = require('backbone');
    var SingleSelectItemsCollection = require('ui/single-select/js/collections/SingleSelectItemsCollection');

    var SingleSelectModel = Backbone.Model.extend({
        defaults : {
            categoryId: -1,
            categoryName : "",
            items : [
                {   //todo move this to the item model ( create item models )
                    id : -1,
                    name : "",
                    isSelected : false,
                    isDisabled : false
                }
            ]
        },

        initialize : function () {
            var singleSelectItemsCollection = new SingleSelectItemsCollection(this.get("items"));
            this.set("items", singleSelectItemsCollection);
        },

        reset : function () {
        }

    });

    return SingleSelectModel;
});
